import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { usePatrolsStore } from "./patrolsStore/patrolsStore";
import { getSitesByParentGroupAlerts } from "../Alerts/AlertsUtils/getSitesByParentGroupAlerts";

export const ParentGroupsDropDownPatrols = ({
  navBarCollapsed,
}: {
  navBarCollapsed: boolean;
}) => {
  const {
    filtersPatrols,
    setFiltersPatrols,
    setSiteOptionsPatrols,
    setCameraOptionsPatrols,
    parentAccountsPatrols,
    parentAccountsLoadingPatrols,
    setLoadingSitesPatrols,
    getPatrolGroups,
  } = usePatrolsStore();

  const navigate = useNavigate();

  React.useEffect(() => {
    getPatrolGroups(navigate);
  }, []);

  return (
    <div key="parent_groups_dropdown">
      <Autocomplete
        disablePortal
        options={
          parentAccountsPatrols && parentAccountsPatrols.length > 0
            ? parentAccountsPatrols.map((object: any, index: number) => ({
                id: object.id,
                name: object.name,
                index: index,
              }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={
          filtersPatrols.parent_group &&
          parentAccountsPatrols &&
          parentAccountsPatrols.length > 0
            ? {
                id: Number(filtersPatrols.parent_group),
                name:
                  parentAccountsPatrols.find(
                    (obj: any) => obj.id === Number(filtersPatrols.parent_group)
                  )?.name || "",
                index: parentAccountsPatrols.findIndex(
                  (obj: any) => obj.id === Number(filtersPatrols.parent_group)
                ),
              }
            : null
        }
        // loading={parentAccountsLoading}
        onChange={(event, value: any) => {
          setSiteOptionsPatrols([]);
          setCameraOptionsPatrols([]);
          if (value !== null) {
            getSitesByParentGroupAlerts(
              value.id,
              navigate,
              setSiteOptionsPatrols,
              setLoadingSitesPatrols
            );
            setFiltersPatrols((previousState: any) => {
              return {
                ...previousState,
                parent_group: value.id,
                site: "",
                camera: "",
              };
            });
          } else {
            setFiltersPatrols((previousState: any) => {
              return {
                ...previousState,
                parent_group: "",
                site: "",
                camera: "",
              };
            });
          }
        }}
        sx={!navBarCollapsed ? { width: 250 } : { width: 280 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Parent Group"
            helperText="*required"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {parentAccountsLoadingPatrols ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
